'use strict';
import React from 'react';
import { Link } from 'react-router-dom';
import userAction from '../actions/userAction';
import userStore from '../stores/userStore';
import genFunction from '../functions/genFunction';

class NavBar extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleLogout = this.handleLogout.bind(this);
        this.state = {
            userName: userStore.getState().userName,
            permission: userStore.getState().permission,
            subordinate: userStore.getState().subordinate,
            isUserLogin: userStore.getState().isUserLogin,
            staffId: userStore.getState().staffId,
            toggle: false,
        }
    }
    componentDidMount() {
        userStore.listen(this.onChange);
        if (!sessionStorage.getItem('ui')) {
            this.props.history.push('/');
        }
    }
    componentWillUnmount() {
        userStore.unlisten(this.onChange);
    }

    componentDidUpdate(prevState, prevProps) {
        if (!sessionStorage.getItem('ui')) {
            console.log('pass here');
            this.props.history.push('/');
        }
    }
    onChange(state) {
        this.setState({
            userName: state.userName,
            isUserLogin: state.isUserLogin,
            staffId: state.staffId,
            permission: state.permission,
            subordinate: state.subordinate,
        });
    }
    handleClick() {
        this.setState({ toggle: !this.state.toggle });
    }
    handleLogout() {
        userAction.logout();
    }

    render() {
        let loginCt = "";
        let display = this.state.toggle ? "block" : "none";

        if (this.state.isUserLogin) {
            loginCt = (
                <ul className="nav navbar-nav navbar-right">
                    <li className="dropdown" onClick={this.handleClick}>
                        <a className="dropdown-toggle" data-toggle="dropdown" role="button">
                            Welcome, {this.state.userName} <span className="glyphicon glyphicon-triangle-bottom"></span>
                        </a>
                        <ul className="dropdown-menu" style={{ display: display }}>
                            <li>
                                <Link to={'/leave/' + this.state.staffId}>
                                    Apply Leave
                                </Link>
                            </li>
                            {(this.state.subordinate.length > 0 || genFunction.hasPermission(this.state.permission, 2)) ?
                                <li>
                                    <Link to={'/apply/leaveAtd'}>
                                        Apply Attendance/Leave for Staff
                                </Link>
                                </li>
                                : ""}
                            <li>
                                <Link to='/report/create'>
                                    Create Incident Report
                                </Link>
                            </li>
                            <li>
                                <Link to={'/attendance/' + this.state.staffId}>
                                    Time In/Out
                                </Link>
                            </li>
                            <li><Link to="/changePassword">Change Password</Link></li>
                        </ul>
                    </li>
                    <li><button className="btn btn-default btn-lgout" onClick={this.handleLogout}>Logout</button></li>
                </ul>
            );
        }
        return (

            <nav className="nav navbar navbar-default navbar-fixed-top">
                <div className="container-fluid">
                    <span className="navbar-brand" >A4 International</span>
                    {loginCt}
                </div>
            </nav>

        );
    }
}
export default NavBar;


// WEBPACK FOOTER //
// ./app/components/navBar.js